import { configureStore as confStore, createImmutableStateInvariantMiddleware, Middleware } from '@reduxjs/toolkit';

import rootReducer, { AppState } from './reducers/index';

const middlewares: Middleware<NonNullable<unknown>, AppState>[] = [];
if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line global-require
    const { createLogger } = require('redux-logger');
    const logger = createLogger();
    const immutableStateInvariantMiddleware = createImmutableStateInvariantMiddleware();
    middlewares.push(logger, immutableStateInvariantMiddleware);
}

const isDevTestOrQA = (): boolean =>
    process.env.NODE_ENV === 'development' ||
    window.location.origin.includes('test') ||
    window.location.origin.includes('qa');

export const configureStore = () => {
    const store = confStore({
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares),
        devTools: isDevTestOrQA(),
        reducer: rootReducer,
    });

    return store;
};
